



































import { Component, Prop, Ref } from 'vue-property-decorator';
import { CalendarIcon } from 'vue-feather-icons';
import { BDropdown } from 'bootstrap-vue';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import { ITask } from 'admiral-core';
import dayjs from 'dayjs';
import { TaskApi } from '@/services/TaskApi';

@Component({
  name: 'TaskDueDatePopover',
  components: { CalendarIcon },
})
export default class TaskDueDatePopover extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: Object, required: true }) task!: ITask;

  @Ref('dropdown') dropdownRef!: BDropdown;

  dateModel: Date | null = null;

  /** Avoid mounting v-date-picker (heavy) until the user opens the dropdown once. */
  pickerMounted = false;

  attrs = [
    {
      key: 'today',
      dot: true,
      dates: new Date(),
    },
  ];

  get displayText(): string {
    if (!this.task.dueAt) return 'Datum setzen';
    const due = dayjs(this.task.dueAt);
    if (due.isSame(dayjs(), 'day')) return 'Heute';
    return due.year() === dayjs().year() ? due.format('DD.MM') : due.format('DD.MM.YYYY');
  }

  get dueDateClass(): Record<string, boolean> {
    if (!this.task.dueAt) return {};
    const due = dayjs(this.task.dueAt);
    const today = dayjs().startOf('day');
    if (due.isBefore(today, 'day') || due.isSame(today, 'day')) return { 'text-danger': true };
    return {};
  }

  hideMenu() {
    this.dropdownRef?.hide();
  }

  onOverlayOpened() {
    this.dateModel = this.task.dueAt ? new Date(this.task.dueAt) : new Date();
    this.pickerMounted = true;
    const parent = this.$el?.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.add('task-due-date-dropdown-open');
  }

  onOverlayClosed() {
    const parent = this.$el?.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.remove('task-due-date-dropdown-open');
  }

  onPickerInput(date: Date) {
    void this.onDateSelect(date);
  }

  async onDateSelect(date: Date) {
    const newDueAt = date ? new Date(date) : null;
    if (!newDueAt) return;
    try {
      await TaskApi.updateDueDate(this.task.id, this.task, newDueAt);
      this.$set(this.task, 'dueAt', newDueAt);
      this.$emit('due-date-changed');
      this.hideMenu();
      this.$toastr.s('Fälligkeitsdatum wurde aktualisiert.');
    } catch (e) {
      this.$toastr.e('Fälligkeitsdatum konnte nicht geändert werden.');
    }
  }
}
